// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"b667d633","453":"dad23a54","479":"bf25ea91"}[chunkId] + ".chunk.js";
};